import { PartialObserver, Subject } from 'rxjs';

declare global {
	interface Window {
		subjects?: { [key: string]: Subject<any> };
		uncaughtSubjects?: { [key: string]: any };
	}
}

window.subjects = window.subjects ?? {};
window.uncaughtSubjects = window.uncaughtSubjects ?? {};

class RxEventEmitter {
	static get subjects() {
		return window.subjects;
	}

	static get uncaughtSubjects() {
		return window.uncaughtSubjects;
	}

	static set subjects(subject: { [key: string]: Subject<any> }) {
		window.subjects = subject;
	}

	static set uncaughtSubjects(uncaughtSubject: { [key: string]: any }) {
		window.uncaughtSubjects = uncaughtSubject;
	}

	static hasOwnProp = {}.hasOwnProperty;

	static createName(name: string) {
		return `$${name}`;
	}

	static emit(name: string, data: any) {
		return import(/* webpackChunkName: "rxjs" */ 'rxjs').then(args => {
			const fnName = RxEventEmitter.createName(name);
			this.subjects[fnName] || (this.subjects[fnName] = new args.Subject<any>());
			if (!this.subjects[fnName].closed) {
				this.subjects[fnName].next(data);
			}
		});
	}

	static listen(name: string, handler: PartialObserver<any>) {
		return import(/* webpackChunkName: "rxjs" */ 'rxjs').then(args => {
			let fnName = RxEventEmitter.createName(name);
			this.subjects[fnName] || (this.subjects[fnName] = new args.Subject<any>());
			return this.subjects[fnName].subscribe(handler);
		});
	}

	static dispose = () => {
		let subjects = RxEventEmitter.subjects;
		for (let prop in subjects) {
			if (RxEventEmitter.hasOwnProp.call(subjects, prop)) {
				subjects[prop].unsubscribe();
			}
		}
		RxEventEmitter.subjects = {};
	};
}

export default RxEventEmitter;
